<script>
    export let label;
    export let value;
</script>

<div class="form-field">
    <label for={label} >{label}</label>
    <input bind:value id={label} name={label} {...$$restProps} />
</div>

<style>   

input {
    width: 80%;
    border-radius: 6px;
    padding:10px;
}
label {
    width: 80%;
    margin: 10px auto;
    text-align: left;
}
</style>